import { basicInitialState } from 'store/_utils/basicInitialState';
import { TCrmContactsState } from './CrmContactsModal';

export const CrmContactsInitialState: TCrmContactsState = {
  ...basicInitialState,
  crmContacts: null
};
